import {
  LiveBroadcast,
  Sequence
} from '../presentation-config-aggregate-types/presentation-config-aggregate-types';
import { makeAutoObservable } from 'mobx';
import SegmentEntity from '../segment-entity/segment-entity';
import CuePointEntity from '../cue-point-entity/cue-point-entity';

class SequenceEntity {
  private segments: SegmentEntity[];
  private liveBroadcast?: LiveBroadcast;

  constructor (fromDTO: Sequence = {} as Sequence) {
    makeAutoObservable(this);
    this.deserialize(fromDTO);
  }

  public getSegments = (): SegmentEntity[] => {
    return this.segments;
  };

  public getCuePoints = (): CuePointEntity[] => {
    const metaData = this.segments.map(x => x.getCuePoints());
    return this.parseMetadata(metaData);
  };

  public isLiveBroadcast = (): LiveBroadcast | void => {
    if(!this.liveBroadcast) return;
    return this.liveBroadcast;
  };

  public parseMetadata = (cuePoints: CuePointEntity[][][]): CuePointEntity[] => {
    const depth = 2;
    return cuePoints.flat(depth);
  };

  private deserialize = (fromDTO: Sequence): void => {
    this.liveBroadcast = fromDTO.liveBroadcast;
    this.segments = fromDTO.segments && fromDTO.segments.segment ?
      fromDTO.segments.segment.map(x => new SegmentEntity(x))
      : [];
  };
}

export default SequenceEntity;
